import React from "react";
import { colors } from "../../../designSystem/colors/color";
import { ActivityListing, ActivityType, CustomFormActivityListing } from "../../../amorg-common";
import { txt } from "../../../txt";
import { TimelineGraph } from "../../../designSystem/graphs/TimelineGraph";

type ActivityGraphProps = {
    rowHeightPx: number,
    yearMonthStart: Date,
    activities: ActivityListing[],
    onNavigate?: (yearMonthStart: Date) => void;
};
export function ActivityGraph (props: ActivityGraphProps): JSX.Element
{
    const shownTypes: {
        type: ActivityType,
        color: string,
        contentBuilder: (a: ActivityListing) => { title: string, description: string, linkUrl: string; };
    }[] = [
            {
                type: 'WorkgroupMeeting',
                // color: colors.graphs.activityTimeline.getColor('WorkgroupMeeting'),
                color: colors.graphs.activityTimeline.getColor('WorkgroupMeeting'),
                contentBuilder: (a: ActivityListing) =>
                ({
                    title: a.title,
                    description: a.description,
                    linkUrl: `/workgroupmeetings/${a.id}`
                })
            },
            {
                type: 'AnnualWorkgroupStatus',
                color: colors.graphs.activityTimeline.getColor('AnnualWorkgroupStatus'),
                contentBuilder: (a: ActivityListing) =>
                ({
                    title: a.title,
                    description: a.description,
                    linkUrl: `/annualworkgroupstatus/${a.id}`
                }),
            },
            {
                type: 'WorkplaceAssessment',
                color: colors.graphs.activityTimeline.getColor('WorkplaceAssessment'),
                contentBuilder: (a: ActivityListing) =>
                ({
                    title: a.title,
                    description: a.description,
                    linkUrl: `/workplaceassessments/${a.id}`
                }),
            },
            {
                type: 'SafetyInspection',
                color: colors.graphs.activityTimeline.getColor('SafetyInspection'),
                contentBuilder: (a: ActivityListing) =>
                ({
                    title: a.title,
                    description: a.description,
                    linkUrl: `/safetyinspections/${a.id}`
                }),
            },
            {
                type: 'CustomForm',
                color: colors.graphs.activityTimeline.getColor('CustomForm'),
                contentBuilder: (a: ActivityListing) =>
                {
                    const typedActivity: CustomFormActivityListing = a as unknown as CustomFormActivityListing;

                    return {
                        title: a.title,
                        description: a.description,
                        linkUrl: `/customforms/${typedActivity.id}`
                    };
                },
            }
        ];

    return (
        <TimelineGraph
            headerText="Aktuelle aktiviteter"
            rowHeightPx={props.rowHeightPx}
            yearMonthStart={props.yearMonthStart}
            eventGroups={shownTypes.map((itm) => ({
                legend: {
                    text: itm.type === 'CustomForm'
                        ? 'Ergonomisk undersøgelse'
                        : txt.getDynamic(`ActivityType_${itm.type}`),
                    color: itm.color
                },
                events: props.activities
                    .filter((a) => a.activityType === itm.type)
                    .map((a) => ({
                        id: a.id,
                        title: itm.contentBuilder(a).title,
                        description: itm.contentBuilder(a).description,
                        linkUrl: itm.contentBuilder(a).linkUrl,
                        start: a.start,
                        end: a.end
                    }))

            }))}
            onNavigate={props.onNavigate}
        />
    );
}

